import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { LoadingIndicatorModule } from '@frontend/sports/loading-indicator-feature';

import { PrintLoadingIndicatorComponent } from './print-loading-indicator.component';

@NgModule({
    imports: [RouterModule, LoadingIndicatorModule],
    declarations: [PrintLoadingIndicatorComponent],
})
export class PrintModule {}
